module.exports = __webpack_public_path__ + "static/media/circled-g-_1_.6b4f4d0e.svg";